<template>
	<div class="c-brands-page" v-if="isAuth" @scroll="onScroll">
		<Brands ref="multi"></Brands>
	</div>
</template>

<script>
import Brands from '@swipekit/components/brands';

export default {
	components: {
		Brands,
	},

	computed: {
		isAuth: function () {
			return this.$store.getters['users/isAuth'];
		},
	},

	methods: {
		onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
			let buffer = 200;
			if (scrollTop + clientHeight >= scrollHeight - buffer) {
				this.$refs.multi.onEnd();
			} else {
			}
		},
	},
};
</script>

<style lang="scss">
.c-brands-page {
	height: 100vh;
	position: relative;
	overflow-y: auto;
}
</style>
